const COLOR_HEX_REGEXP = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);

// Decomposing hex color into RGB
const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  if (!COLOR_HEX_REGEXP.test(hex)) {
    throw new Error('Invalid hex format.');
  }

  let value = hex.replace('#', '');

  // Check short format hex codes like 2f7
  if (value.length === 3) {
    // In case of short format - just duplicate all values in the string
    // to be 22ff77
    value = [...value].reduce((acc, stringValue) => {
      return acc + stringValue + stringValue;
    }, '');
  }

  // Parse hex values for red, green, and blue
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);

  return { r, g, b };
};

// Get a plain rgba color, you have to provide a hex color and opacity (in the
// range 0.0 (fully transparent) to 1.0 (fully opaque))
export const colorAlpha = (hex: string, opacity: number) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
